import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../css/Menu.css';
import { UserContext } from '../contexts/UserContext';
import PersonIcon from '@mui/icons-material/Person';
import ChangePasswordModal from './ChangePasswordModal'; // <-- Importar el modal

export default function Menu() {
  const [utilOpen, setUtilOpen] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const [accessOpen, setAccessOpen] = useState(false);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false); // <-- Estado del modal

  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();

  const isAdmin = Number(user?.idRol ?? user?.id_rol) === 1;

  const toggleUtil = () => {
    setUtilOpen(!utilOpen);
    setAccessOpen(false);
    setUserOpen(false);
  };

  const toggleAccess = () => {
    setAccessOpen(!accessOpen);
    setUtilOpen(false);
    setUserOpen(false);
  };

  const toggleUser = () => {
    setUserOpen(!userOpen);
    setAccessOpen(false);
    setUtilOpen(false);
  };

  const handleLogout = () => {
    setUserOpen(false);
    localStorage.removeItem("user");
    setUser(null);
    navigate('/');
  };

  const getUserDisplayName = () => {
    if (!user) return 'consulta@simsan.org.gt';
    const primerNombre = user.firstName || user.first_name || '';
    const primerApellido = user.firstSurname || user.first_surname || '';
    const nombreCompleto = `${primerNombre} ${primerApellido}`.trim();
    return nombreCompleto || user.username || user.email || 'Mi Usuario';
  };

  useEffect(() => { // <-- Cierrar los menús desplegables al hacer clic fuera de ellos
    const handleClickOutside = (event) => {
      if (!event.target.closest('.submenu-container')) {
        setAccessOpen(false);
        setUtilOpen(false);
        setUserOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <nav className="menu-bar">
        <div className="menu-left">
          <Link to="/home" className="menu-item home-button">
            <img src="/images/home.png" alt="Home" className="home-icon" />
          </Link>

          <Link to="/tablero" className="menu-item">Tablero</Link>
          <Link to="/datos" className="menu-item">Datos Recolectados</Link>

          {/* Submenú Util */}
          {/* <div className="submenu-container">
            <button onClick={toggleUtil} className="submenu-button">
              Util <span>▼</span>
            </button>
            {utilOpen && (
              <div className="submenu">
                <Link to="/util/obtener" className="submenu-item" onClick={() => setUtilOpen(false)}>
                  Obtener datos
                </Link>
                <Link to="/util/actualizar" className="submenu-item" onClick={() => setUtilOpen(false)}>
                  Actualizar base de datos
                </Link>
              </div>
            )}
          </div> */}

          {/* Submenú Acceso */}
          {isAdmin && (
            <div className="submenu-container">
              <button onClick={toggleAccess} className="submenu-button">
                Acceso <span>▼</span>
              </button>
              {accessOpen && (
                <div className="submenu">
                  <Link to="/acceso/usuarios" className="submenu-item" onClick={() => setAccessOpen(false)}>
                    Usuarios
                  </Link>
                  <Link to="/acceso/aplicaciones" className="submenu-item" onClick={() => setAccessOpen(false)}>
                    Aplicaciones
                  </Link>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Menú derecho */}
        <div className="menu-right">
          <div className="submenu-container">
            <button onClick={toggleUser} className="submenu-button">
              <PersonIcon fontSize="small" />
              <span>{getUserDisplayName()}</span>
              <span>▼</span>
            </button>

            {userOpen && (
              <div className="submenu">
                <Link 
                  to="/mi-usuario" 
                  className="submenu-item" 
                  onClick={() => setUserOpen(false)}
                >
                  Perfil
                </Link>
                <button 
                  className="submenu-item" 
                  onClick={() => {
                    setUserOpen(false);
                    setPasswordModalOpen(true); // <-- Abre el modal
                  }}
                >
                  Cambiar contraseña
                </button>
                <button 
                  className="submenu-item" 
                  onClick={handleLogout}
                >
                  Cerrar sesión
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* MODAL DE CAMBIO DE CONTRASEÑA */}
      <ChangePasswordModal
        open={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        userId={user?.id}
      />
    </>
  );
}